<script lang="ts">
  import { Colors } from "../../../../utils/Constant/Constant";
  import {colors} from "../../../../store";
  import data from "../../../../Data/Ecommerce/Ecommerce.json"
  // for colors
  const handleColor =(result)=>{
    colors.update(value => value = result)
  }

</script>
<div class="product-filter slider-product">
    <h6 class="f-w-600">{Colors}</h6>
    <div class="color-selector">
      <ul>
        {#each data.colorsdata as colorItem }
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <li class="{colorItem.class} me-2" value={colorItem.color} on:click={()=>handleColor(colorItem.color)}></li>
        {/each}
      </ul>
    </div>
</div>